export const USER_TYPES = {
	CONSUMER: "consumer",
	ADMIN: "admin",
	TRAINER: "trainer",
};

const USER_SUBSCRIPTION_STATUSES = {
	ACTIVE: "ACTIVE",
	EXPIRED: "EXPIRED",
	CANCELLED: "CANCELLED",
	TRIAL: "TRIAL",
};

export const isUserAdmin = (user_type) => user_type === USER_TYPES.ADMIN;

export const isUserCreator = (user_type) => {
	return [USER_TYPES.ADMIN, USER_TYPES.TRAINER].includes(user_type);
};

export const isUserMember = (user_type, subscription_status) => {
	return (
		user_type === USER_TYPES.CONSUMER &&
		![USER_SUBSCRIPTION_STATUSES.CANCELLED, USER_SUBSCRIPTION_STATUSES.EXPIRED].includes(subscription_status)
	);
};
